export function getArrowTemplate() {
  return '<svg class="icon-arrow-down" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"\n' +
    '     viewBox="0 0 16 8" style="enable-background:new 0 0 16 8;" xml:space="preserve">\n' +
    '    <g>\n' +
    '\t<polygon points="8,7.8 0.6,0.4 1.3,-0.4 8,6.4 14.7,-0.4 15.4,0.4 \t"/>\n' +
    '</g>\n' +
    '</svg>';
}


// WEBPACK FOOTER //
// ./assets/js/modules/getArrowTemplate.js